import React from 'react';

// Main mascot - Friendly owl with VR glasses, laptop and star badge
export const OwlMascot = ({ size = 200, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Body */}
    <ellipse cx="100" cy="120" rx="55" ry="60" fill="#007BFF" />
    {/* Belly */}
    <ellipse cx="100" cy="135" rx="35" ry="38" fill="#E8F0FE" />
    {/* Circuit patterns on wings */}
    <path d="M45 110 Q35 100 40 85 Q42 78 48 82" stroke="#B0C4DE" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M42 95 L35 92" stroke="#B0C4DE" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="35" cy="92" r="2" fill="#B0C4DE" />
    <path d="M155 110 Q165 100 160 85 Q158 78 152 82" stroke="#B0C4DE" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M158 95 L165 92" stroke="#B0C4DE" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="165" cy="92" r="2" fill="#B0C4DE" />
    {/* Head */}
    <circle cx="100" cy="72" r="42" fill="#007BFF" />
    {/* Face disc */}
    <circle cx="100" cy="76" r="32" fill="#E8F0FE" />
    {/* Left eye area */}
    <circle cx="84" cy="72" r="14" fill="white" stroke="#005ACC" strokeWidth="1" />
    <circle cx="84" cy="72" r="8" fill="#FF6F00" />
    <circle cx="82" cy="70" r="3" fill="white" />
    {/* Right eye area */}
    <circle cx="116" cy="72" r="14" fill="white" stroke="#005ACC" strokeWidth="1" />
    <circle cx="116" cy="72" r="8" fill="#FF6F00" />
    <circle cx="114" cy="70" r="3" fill="white" />
    {/* Beak */}
    <path d="M96 84 L100 92 L104 84" fill="#FF8C00" />
    {/* VR Glasses */}
    <rect x="65" y="56" rx="5" ry="5" width="70" height="18" fill="#1E1E1E" opacity="0.85" />
    <rect x="68" y="59" rx="3" ry="3" width="27" height="12" fill="#334155" />
    <rect x="105" y="59" rx="3" ry="3" width="27" height="12" fill="#334155" />
    <line x1="95" y1="65" x2="105" y2="65" stroke="#1E1E1E" strokeWidth="2" />
    <circle cx="80" cy="65" r="3" fill="#007BFF" opacity="0.6" />
    <circle cx="120" cy="65" r="3" fill="#FF6F00" opacity="0.6" />
    {/* Ear tufts */}
    <path d="M68 42 L60 25 L75 38" fill="#005ACC" />
    <path d="M132 42 L140 25 L125 38" fill="#005ACC" />
    {/* Star badge on chest */}
    <polygon points="100,108 103,114 110,115 105,120 106,127 100,124 94,127 95,120 90,115 97,114" fill="#FF6F00" />
    <polygon points="100,111 102,115 106,115.5 103,118.5 104,123 100,121 96,123 97,118.5 94,115.5 98,115" fill="#FFD700" />
    {/* Left wing holding laptop */}
    <path d="M50 115 Q40 125 45 140 Q50 148 55 145 L60 130" fill="#005ACC" />
    {/* Laptop */}
    <rect x="35" y="140" rx="2" ry="2" width="28" height="18" fill="#1E1E1E" />
    <rect x="37" y="142" rx="1" ry="1" width="24" height="12" fill="#334155" />
    <text x="44" y="151" fontSize="7" fill="#007BFF" fontWeight="bold">AI</text>
    <rect x="33" y="158" rx="1" ry="1" width="32" height="3" fill="#2D2D2D" />
    {/* Right wing waving */}
    <path d="M150 115 Q162 108 165 95 Q167 88 160 92 Q155 96 152 105" fill="#005ACC" />
    {/* Feet */}
    <path d="M82 175 L78 185 L85 182 L90 185 L88 175" fill="#FF8C00" />
    <path d="M112 175 L108 185 L115 182 L120 185 L118 175" fill="#FF8C00" />
  </svg>
);

// Mini version for favicon/badges/icons
export const OwlMini = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="20" cy="22" r="14" fill="#007BFF" />
    <circle cx="20" cy="18" r="10" fill="#E8F0FE" />
    <circle cx="16" cy="17" r="4" fill="white" stroke="#005ACC" strokeWidth="0.5" />
    <circle cx="16" cy="17" r="2.5" fill="#FF6F00" />
    <circle cx="15.5" cy="16.5" r="1" fill="white" />
    <circle cx="24" cy="17" r="4" fill="white" stroke="#005ACC" strokeWidth="0.5" />
    <circle cx="24" cy="17" r="2.5" fill="#FF6F00" />
    <circle cx="23.5" cy="16.5" r="1" fill="white" />
    <path d="M19 21 L20 23 L21 21" fill="#FF8C00" />
    <rect x="12" y="13" rx="2" ry="2" width="16" height="5" fill="#1E1E1E" opacity="0.8" />
    <rect x="13.5" y="14" rx="1" ry="1" width="5" height="3" fill="#334155" />
    <rect x="21.5" y="14" rx="1" ry="1" width="5" height="3" fill="#334155" />
    <path d="M12 10 L10 4 L14 9" fill="#005ACC" />
    <path d="M28 10 L30 4 L26 9" fill="#005ACC" />
    <polygon points="20,26 21.5,28.5 24,29 22,31 22.5,33.5 20,32 17.5,33.5 18,31 16,29 18.5,28.5" fill="#FFD700" />
  </svg>
);

// Learning owl for course illustrations
export const OwlLearning = ({ size = 120, className = '' }) => (
  <svg width={size} height={size * 1.1} viewBox="0 0 120 132" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Body sitting */}
    <ellipse cx="60" cy="82" rx="35" ry="38" fill="#007BFF" />
    <ellipse cx="60" cy="92" rx="22" ry="24" fill="#E8F0FE" />
    {/* Head */}
    <circle cx="60" cy="45" r="28" fill="#007BFF" />
    <circle cx="60" cy="48" r="21" fill="#E8F0FE" />
    {/* Eyes - focused downward */}
    <circle cx="51" cy="46" r="9" fill="white" stroke="#005ACC" strokeWidth="0.8" />
    <circle cx="51" cy="48" r="5.5" fill="#FF6F00" />
    <circle cx="50" cy="47" r="2" fill="white" />
    <circle cx="69" cy="46" r="9" fill="white" stroke="#005ACC" strokeWidth="0.8" />
    <circle cx="69" cy="48" r="5.5" fill="#FF6F00" />
    <circle cx="68" cy="47" r="2" fill="white" />
    {/* Beak */}
    <path d="M57 55 L60 60 L63 55" fill="#FF8C00" />
    {/* VR glasses pushed up */}
    <rect x="40" y="30" rx="4" ry="4" width="40" height="10" fill="#1E1E1E" opacity="0.7" />
    {/* Ear tufts */}
    <path d="M40 26 L35 14 L45 24" fill="#005ACC" />
    <path d="M80 26 L85 14 L75 24" fill="#005ACC" />
    {/* Book */}
    <rect x="30" y="95" rx="2" ry="2" width="60" height="8" fill="#1E1E1E" />
    <rect x="32" y="85" rx="2" ry="2" width="26" height="12" fill="#E8F0FE" stroke="#B0C4DE" strokeWidth="0.8" />
    <rect x="62" y="85" rx="2" ry="2" width="26" height="12" fill="#F0F4FF" stroke="#B0C4DE" strokeWidth="0.8" />
    <line x1="60" y1="85" x2="60" y2="97" stroke="#007BFF" strokeWidth="1.5" />
    <line x1="36" y1="89" x2="54" y2="89" stroke="#B0C4DE" strokeWidth="0.8" />
    <line x1="36" y1="92" x2="50" y2="92" stroke="#B0C4DE" strokeWidth="0.8" />
    <line x1="66" y1="89" x2="84" y2="89" stroke="#B0C4DE" strokeWidth="0.8" />
    <line x1="66" y1="92" x2="80" y2="92" stroke="#B0C4DE" strokeWidth="0.8" />
    {/* Lightbulb above head */}
    <circle cx="60" cy="8" r="7" fill="#FFD700" opacity="0.9" />
    <rect x="58" y="14" width="4" height="3" rx="1" fill="#FFB800" />
    <line x1="60" y1="4" x2="60" y2="2" stroke="#FF6F00" strokeWidth="1" strokeLinecap="round" />
    <line x1="54" y1="5" x2="52" y2="3" stroke="#FF6F00" strokeWidth="1" strokeLinecap="round" />
    <line x1="66" y1="5" x2="68" y2="3" stroke="#FF6F00" strokeWidth="1" strokeLinecap="round" />
    {/* Wings holding book */}
    <path d="M28 75 Q22 82 25 92 L30 92" fill="#005ACC" />
    <path d="M92 75 Q98 82 95 92 L90 92" fill="#005ACC" />
    {/* Feet */}
    <path d="M48 118 L45 125 L50 123 L54 125 L52 118" fill="#FF8C00" />
    <path d="M68 118 L65 125 L70 123 L74 125 L72 118" fill="#FF8C00" />
  </svg>
);
